import { makeCall } from '../api.js';


export const logicRegisterSupplier = (data) => {
    return makeCall({
        method: 'POST',
        action: 'manageraccount/register',
        body: JSON.stringify(data)
    });
};



/** WEBPACK FOOTER **
 ** ./src/logic/api/supplier.js
 **/